function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.241 0A7.245 7.245 0 000 7.241c0 1.165.606 2.805 1.492 4.519 1.952 3.775 5.204 7.973 5.204 7.973a.69.69 0 001.09 0s3.253-4.198 5.205-7.973c.886-1.714 1.492-3.354 1.492-4.519A7.245 7.245 0 007.24 0zm0 4.138A3.105 3.105 0 004.138 7.24a3.105 3.105 0 003.103 3.104 3.105 3.105 0 003.104-3.104A3.105 3.105 0 007.24 4.138z",
  fill: "#404040"
});

function SvgLocationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgLocationIcon;